import { Sheet } from "service/sheet/type";
import { DraftModel, DraftCharacter } from "types/Draft/type";
import { CharacterBox, Player } from "types/Player/type";

export type Room = {
  params: RoomParams;
  draftModel: DraftModel;
  player1?: Player;
  player2?: Player;
  player3?: Player;
  player4?: Player;
  // Box d'équipe : union des box de l'équipe (en 1vs1, la box du joueur), figée pendant la draft.
  teamBoxPlayer1?: CharacterBox[];
  teamBoxPlayer2?: CharacterBox[];
  spectators: Player[];
  balancingBansPlayer1?: DraftCharacter[];
  jokerBansPlayer1?: DraftCharacter[];
  balancingBansPlayer2?: DraftCharacter[];
  jokerBansPlayer2?: DraftCharacter[];
};

export type RoomState = {
  name: string;
  state: "InWaitingRoom" | "InDraft" | "EndDraft";
  privateRoom: boolean;
};

export type Role =
  | "Player 1"
  | "Player 2"
  | "Player 3"
  | "Player 4"
  | "Spectator";

export enum PlayersNumber {
  _1vs1 = "1vs1",
  _2vs2 = "2vs2",
}
export const PlayersNumberDictionary: { [key in PlayersNumber]: string } = {
  [PlayersNumber._1vs1]: "1 vs 1",
  [PlayersNumber._2vs2]: "2 vs 2",
};

export enum GameMode {
  SpiralAbyss = "SpiralAbyss",
  StygianOnslaught = "StygianOnslaught",
}
export const GameModeDictionary: { [key in GameMode]: string } = {
  [GameMode.SpiralAbyss]: "Profondeurs spiralées",
  [GameMode.StygianOnslaught]: "Carnage chtonien",
};

export type RoomParams = {
  name: string;
  privateRoom: boolean;
  sheet: Pick<Sheet, "name" | "id">;
  playersNumber: PlayersNumber;
  gameMode: GameMode;
  // Mode solo (bac à sable) : room privée à un seul joueur, qui joue les deux camps.
  solo?: boolean;
};
